import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { Stack } from '../../../components/Stack';
import { useAppLayoutContext } from '../AppLayout.context';
import { appLayoutBodyStyles } from './AppLayoutBody.styles';
export const AppLayoutBody = forwardRef(function AppLayoutBody(props, forwardedRef) {
    const { styles, sx, children, ...other } = props;
    const appLayoutContext = useAppLayoutContext();
    const { combineStyles, globalStyles } = useStyles({
        name: 'AppLayoutBody',
        styles: [appLayoutBodyStyles, styles],
    });
    const hasHeader = appLayoutContext.components.includes('header');
    const hasAside = appLayoutContext.components.includes('aside');
    return (_jsx(Stack, { as: 'main', align: 'start', horizontal: true, ...other, sx: [
            globalStyles,
            combineStyles('host', hasHeader && 'host$hasHeader', hasAside && 'host$hasAside'),
            sx,
        ], ref: forwardedRef, children: children }));
});
